import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib';
import {
  cancelCheckinDeleteCompanionResultRequest,
  failCheckinDeleteCompanionResult,
  setCheckinDeleteCompanionResult,
  setCheckinDeleteCompanionResultFromApi,
  updateCheckinDeleteCompanionResult,
  updateCheckinDeleteCompanionResultFromApi,
} from './checkin-delete-companion-result.actions';

/**
 * Service to handle async CheckinDeleteCompanionResult actions
 */
@Injectable()
export class CheckinDeleteCompanionResultEffect {
  /**
   * Set the state with the reply content, dispatch failCheckinDeleteCompanionResult if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setCheckinDeleteCompanionResultFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setCheckinDeleteCompanionResult({ model: reply, requestId: action.requestId }),
        (error, action) => of(failCheckinDeleteCompanionResult({ error, requestId: action.requestId })),
        cancelCheckinDeleteCompanionResultRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failCheckinDeleteCompanionResult if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateCheckinDeleteCompanionResultFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateCheckinDeleteCompanionResult({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failCheckinDeleteCompanionResult({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
